import React, { useState } from "react";
import Modal from "react-modal";
import { BsFillExclamationTriangleFill } from "react-icons/bs";

import Styles from "./ModalAceitarTermos.module.css";
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

type ModalAceitarTermosProps = {
  isOpen: boolean;
  handleAceitar: () => Promise<void>;
  handleCancelar: () => void;
};

export default function ModalAceitarTermos({
  isOpen,
  handleAceitar,
  handleCancelar,
}: ModalAceitarTermosProps): JSX.Element {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isChecked) {
      await handleAceitar();
    }
  };

  return (
    <Modal isOpen={isOpen} className={Styles.ModalAceitarTermos}>
      <form className={Styles.modalContainer} onSubmit={handleSubmit}>
        <div className={Styles.iconeContainer}>
          <BsFillExclamationTriangleFill className={Styles.iconeAtencao} />
        </div>
        <div className={Styles.modalCabecalho}>
          <h1 className={Styles.cabecalhoText}>
            {t("termsOfUse.title", "Termos de Uso")}
          </h1>
        </div>
        <div className={Styles.termosContainer}>
          <p>
            {t(
              "termsOfUse.text",
              "Ao continuar, você aceita os Termos de Uso e a Política de Privacidade."
            )}
          </p>
          <div className={Styles.checkboxContainer}>
            <input
              type="checkbox"
              id="acceptTerms"
              checked={isChecked}
              onChange={() => setIsChecked(oldState => !oldState)}
            />
            <label htmlFor="acceptTerms">
              {t(
                "termsOfUse.accept",
                "Eu li e aceito os Termos de Uso e a Política de Privacidade."
              )}
            </label>
          </div>
        </div>
        <div className={Styles.buttons}>
          <button type="button" onClick={handleCancelar}>
            {t("termsOfUse.cancel", "Cancelar")}
          </button>
          <button type="submit" disabled={!isChecked}>
            {t("termsOfUse.acceptButton", "Aceitar")}
          </button>
        </div>
      </form>
    </Modal>
  );
}
